<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="handleClose">
        <el-descriptions :column="1" border>
            <el-descriptions-item v-for="(item, index) in items" :label="item.label" :key="index">{{ item.value }}</el-descriptions-item>
          <!-- <el-descriptions-item :label="dialogData.scoreLable">{{ dialogData.score }}</el-descriptions-item>
          <el-descriptions-item :label="dialogData.npsTypeLable">{{ dialogData.npsType }}</el-descriptions-item>
          <el-descriptions-item :label="dialogData.commentLable">{{ dialogData.comment }}</el-descriptions-item> -->
        </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ cancelButtonText }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ confirmButtonText }}</el-button>
      </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "Dialog",
        props: ["dialogData", "title"],
        data() {
            return {
                dialogVisible : false,
                confirmButtonText: window.$t('mis.nps.confirmButton'),
                cancelButtonText: window.$t('mis.nps.cancleButton'),
            }
        },
        computed: {
            items: {
                get() {
                    return JSON.parse(JSON.stringify(this.dialogData));
                }
            }
        },
        methods: {
            show() {
                this.dialogVisible = true;
            },
            handleClose() {
                this.dialogVisible = false;
            }
        }
    }
</script>

<style scoped>

</style>